/**
 * Booking channels supported across every STR integration.
 *
 * This list is owned by the frontend. `value` is what the API stores/returns in
 * the `disabled_booking_channels` array, `label` is what the user sees.
 *
 * `BOOKING_CHANNELS_SOURCE`'s own order doesn't matter — add a new channel
 * anywhere in it (appending is simplest). `STR_BOOKING_CHANNELS`, the one every
 * other file imports, is sorted alphabetically by `label` once at module load,
 * so the render order in the Manage Booking Channels drawer stays correct
 * automatically with no manual re-ordering.
 */
const BOOKING_CHANNELS_SOURCE = [
    { value: 'agoda', label: 'Agoda' },
    { value: 'airbnb', label: 'Airbnb' },
    { value: 'alvhr', label: 'Alabama Vacation Home Rentals' },
    { value: 'anystay', label: 'AnyStay' },
    { value: 'arrange_your_vacation', label: 'Arrange Your Vacation' },
    { value: 'avanti', label: 'Avanti' },
    { value: 'big_bridge_travel', label: 'Big Bridge Travel' },
    { value: 'blueground', label: 'Blueground' },
    { value: 'bnbfinder', label: 'BnBFinder' },
    { value: 'boarding', label: 'Boarding' },
    { value: 'book_direct_forgotten_coast', label: 'Book Direct Forgotten Coast' },
    { value: 'booking_com', label: 'Booking.com' },
    { value: 'boutique_homes', label: 'Boutique Homes' },
    { value: 'branson_premier', label: 'Branson Premier' },
    { value: 'broken_bow', label: 'Broken Bow' },
    { value: 'canadastays', label: 'CanadaStays' },
    { value: 'carolina_vacation_home_rentals', label: 'Carolina Vacation Home Rentals' },
    { value: 'castle_cave', label: 'Castle Cave' },
    { value: 'cavrbo', label: 'California Vacation Rentals' },
    { value: 'co_vacation_homes', label: 'Co Vacation Homes' },
    { value: 'cottages_in_canada', label: 'Cottages In Canada' },
    { value: 'crewdogs', label: 'Crewdogs' },
    { value: 'despegar', label: 'Despegar' },
    { value: 'domegos', label: 'Domegos (defunct)' },
    { value: 'ecbyo', label: 'Emerald Coast By Owner' },
    { value: 'everystay', label: 'EveryStay' },
    { value: 'expedia', label: 'Expedia' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'find_rentals', label: 'Find Rentals' },
    { value: 'flataway', label: 'Flataway' },
    { value: 'flipkey', label: 'FlipKey' },
    { value: 'florida_30a', label: 'Florida 30A' },
    { value: 'florida_rental_by_owners', label: 'Florida Rental By Owners' },
    { value: 'florida_rentals', label: 'Florida Rentals' },
    { value: 'foxhole', label: 'Foxhole' },
    { value: 'free_vacation_rental_site', label: 'Free Vacation Rental Site' },
    { value: 'get_away_digs', label: 'Get Away Digs' },
    { value: 'getaway_go_go', label: 'GetawayGoGo' },
    { value: 'glamping_hub', label: 'GlampingHub' },
    { value: 'golightly', label: 'Golightly' },
    { value: 'google', label: 'Google Vacation Rentals' },
    { value: 'got2go', label: 'Got2Go' },
    { value: 'guest_smiles', label: 'GuestSmiles' },
    { value: 'hawaii_vr', label: 'Hawaii Vr' },
    { value: 'holidaylettings', label: 'HolidayLettings' },
    { value: 'homads', label: 'Homads' },
    { value: 'home_escape', label: 'Home Escape' },
    { value: 'marriott', label: 'Homes & Villas by Marriott' },
    { value: 'hometogo', label: 'HomeToGo' },
    { value: 'hopper', label: 'Hopper Homes' },
    { value: 'hostelworld', label: 'Hostelworld' },
    { value: 'houfy', label: 'Houfy' },
    { value: 'inhaven', label: 'Inhaven' },
    { value: 'kopa', label: 'Kopa' },
    { value: 'lake', label: 'Lake.com' },
    { value: 'local_ota', label: 'Local OTA' },
    { value: 'lodgelovers', label: 'LodgeLovers' },
    { value: 'mdrbo', label: 'MD/DE Vacation Rental by Owners' },
    { value: 'ministays', label: 'MiniStays' },
    { value: 'misterbnb', label: 'misterb&b' },
    { value: 'mrbo_and_american_snowbird', label: 'MRBO & American Snowbird' },
    { value: 'nextpax', label: 'NextPax' },
    { value: 'nineflats', label: 'NineFlats (defunct)' },
    { value: 'nofie', label: 'Nofie' },
    { value: 'nybyo', label: 'New York Rental By Owner' },
    { value: 'ownerdirect', label: 'OwnerDirect' },
    { value: 'perfect_places', label: 'Perfect Places' },
    { value: 'redawning', label: 'RedAwning' },
    { value: 'rental_bug', label: 'Rental Bug' },
    { value: 'rentals_united', label: 'Rentals United' },
    { value: 'rentalz', label: 'Rentalz' },
    { value: 'savvy', label: 'Savvy' },
    { value: 'sayulita_life', label: 'Sayulita Life' },
    { value: 'shenandoah_cabin_rentals', label: 'Shenandoah Cabin Rentals' },
    { value: 'smbyo', label: 'Smoky Mountains By Owner' },
    { value: 'smoky_mountains', label: 'Smokymountains.com' },
    { value: 'spain_holiday', label: 'Spain Holiday' },
    { value: 'stay', label: 'Stay' },
    { value: 'staymentity', label: 'StayMentity' },
    { value: 'staynearn', label: 'Staynearn' },
    { value: 'tex_escapes', label: 'Tex Escapes' },
    { value: 'tnrbo', label: 'TNRBO' },
    { value: 'tramona', label: 'Tramona' },
    { value: 'travelstaytion', label: 'Travelstaytion' },
    { value: 'tripadvisor', label: 'TripAdvisor' },
    { value: 'trip_skip', label: 'TripSkip' },
    { value: 'us_vi', label: 'US Virgin Islands' },
    { value: 'va_vacation_rentals', label: 'Virginia Vacation Rentals' },
    { value: 'vacation_home_rentals', label: 'Vacation Home Rentals' },
    { value: 'vacation_rental_people', label: 'Vacation Rental People' },
    { value: 'vacation_rentals', label: 'Vacation Rentals' },
    { value: 'vacation_rentals_wildwood', label: 'Vacation Rentals Wildwood' },
    { value: 'vacay_my_way', label: 'VacayMyWay' },
    { value: 'vast_trips', label: 'Vast Trips' },
    { value: 'vidle_housing', label: 'Vidle Housing' },
    { value: 'vrasio', label: 'Vrasio' },
    { value: 'vrbo', label: 'Vrbo' },
    { value: 'vrlbi', label: 'Vacation Rentals LBI' },
    { value: 'vrocnj', label: 'Vacation Rentals Ocean City NJ' },
    { value: 'vrwd', label: 'VRWD' },
    { value: 'wander', label: 'Wander' },
    { value: 'whimstay', label: 'Whimstay' },
    { value: 'thirty_a_home_rentals', label: '30A Home Rentals' },
    { value: 'owner_block_off', label: 'Owner Block-off' },
    { value: 'pikpakgo', label: 'PikPakGo' },
    { value: 'referral', label: 'Referral' },
];

export const STR_BOOKING_CHANNELS = [...BOOKING_CHANNELS_SOURCE].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
);

export const TOTAL_BOOKING_CHANNELS = STR_BOOKING_CHANNELS.length;
